import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getAccounting } from "./api";

export default function AccountingPage() {
  const { id } = useParams();
  const [rows, setRows] = useState([]);

  const fetchAccounting = async () => {
    const rows = await getAccounting(id);
    setRows(rows);
  }

  useEffect(() => {
    fetchAccounting();
  }, []);

  const columns = [
    { field: "date", headerName: "Date", width: 120 },
    { field: "rnr_code", headerName: "RNR", width: 100 },
    { field: "description", headerName: "Description", width: 250 },
    { field: "debit", headerName: "Debit", width: 120 },
    { field: "credit", headerName: "Credit", width: 120 }
  ];

  const specialRows = ["1000", "2000", "3000", "4001", "4002"];


  return (
    <DataGrid
      rows={rows}
      columns={columns}
      getRowId={r => r.source_ref}
      getRowClassName={(params) =>
        specialRows.includes(params.row.rnr_code)
          ? `rnr-${params.row.rnr_code}`
          : ""
      }
    />
  );

}
